import {Component, OnDestroy} from '@angular/core';
import {DocumentHal} from '../../models/HAL/document-hal.model';
import {ActivatedRoute} from '@angular/router';
import {PreviewDocumentComponent} from '../../components/preview-document/preview-document.component';
import {
  PreviewDocumentMetadataComponent
} from '../../components/preview-document-metadata/preview-document-metadata.component';
import {PreviewFormComponent} from '../../components/preview-form/preview-form.component';
import {PreviewFormMetadataComponent} from '../../components/preview-form-metadata/preview-form-metadata.component';

import {
  CollaboratorPreviewFormMetadataComponent
} from '../../collaborator/components/collaborator-preview-form-metadata/collaborator-preview-form-metadata.component';
import {CollaboratorHelperService} from '../../services/collaborator-helper.service';
import {
  CollaboratorPreviewPdfMetadataComponent
} from '../../collaborator/components/collaborator-preview-pdf-metadata/collaborator-preview-pdf-metadata.component';
import {CommentContextService} from '../../services/comment-context.service';

@Component({
  selector: 'app-document-preview',
  imports: [
    PreviewDocumentComponent,
    PreviewDocumentMetadataComponent,
    PreviewFormComponent,
    PreviewFormMetadataComponent,
    CollaboratorPreviewFormMetadataComponent,
    CollaboratorPreviewPdfMetadataComponent
  ],
  templateUrl: './document-preview.component.html',
  styleUrl: './document-preview.component.scss'
})
export class DocumentPreviewComponent implements OnDestroy {

  documentHal: DocumentHal;

  constructor(
    activatedRoute: ActivatedRoute,
    public readonly collaboratorHelperService: CollaboratorHelperService,
    private readonly commentContextService: CommentContextService
  ) {
    this.documentHal = new DocumentHal(activatedRoute.snapshot.data['document']);
    if (!this.collaboratorHelperService.isCollaboratorView) {
      this.commentContextService.setPanelHal(this.documentHal);
    }
  }

  ngOnDestroy(): void {
    if (!this.collaboratorHelperService.isCollaboratorView) {
      this.commentContextService.setPanelHal(null);
    }
  }
}
